import $ from 'jquery';
import slick from 'slick-carousel';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

// function wordReveal() {
//   gsap.registerPlugin(SplitText);
  
//   const elements = document.querySelectorAll('.hero-image')
  
//   elements.forEach((element, i) => {
//     const heroTitle = element.querySelector('.hero-title')
//     gsap.set(heroTitle, { autoAlpha: 1, y: 0 })
//     gsap.from(heroTitle, {
//       y: 40,
//       duration: 1.2,
//       autoAlpha: 0,
//       repeatRefresh: true,
//       ease: 'cubic-bezier( .56 , .52 , .53 , 1.25 )',
//     })

//     const text = element.querySelector('.hero-subtitle')
//     gsap.set(text, { autoAlpha: 1 });

//     var splitHide = new SplitText(text, { type: "words", wordsClass: "hide" });
//     var split = new SplitText(text, {
//       type: "words",
//       wordsClass: "words",
//     });

//     gsap.from(split.words, {
//       delay: .8,
//       duration: 1.2,
//       yPercent: 15,
//       stagger: .2,
//       autoAlpha: 0,
//       ease: 'cubic-bezier( .56 , .52 , .53 , 1.25 )',
//     });

//     const heroCTA = element.querySelector('.hero-cta')
//     gsap.set(heroCTA, { autoAlpha: 1, y: 0 })
//     gsap.from(heroCTA, {
//       delay: 2,
//       duration: 1.2,
//       autoAlpha: 0
//     })
//   });
// }

// init
$( () => {
  let $slickElement = $('[data-slick]');

  if ( $slickElement.length ) {
    // nav slider left
    $('.prev').on( 'click' , (e) => {
      e.preventDefault();
      $slickElement.slick('slickPrev');
    });
    
    // nav slider right
    $('.next').on( 'click' , (e) => {
      e.preventDefault();
      $slickElement.slick('slickNext');
    });

    // CPT slider left
    $('.cpt-prev').on( 'click' , (e) => {
      e.preventDefault();
      let $ownSlick = $( e.currentTarget ).parent().parent().next();
      $ownSlick.slick('slickPrev');
    });

    $( '.lg-prev' ).on( 'click', (e) => {
      let $ownParentID = $( e.currentTarget ).parent().parent().parent().attr( 'id' );
      let $lgSlick = $( `[data-lg="${ $ownParentID }"]` )
      
      $lgSlick.slick( 'slickPrev' );
    } )
    
    // CPT slider right
    $('.cpt-next').on( 'click' , (e) => {
      e.preventDefault();
      let $ownSlick = $( e.currentTarget ).parent().parent().next();
      $ownSlick.slick('slickNext');
    });

    $( '.lg-next' ).on( 'click', (e) => {
      let $ownParentID = $( e.currentTarget ).parent().parent().parent().attr( 'id' );
      let $lgSlick = $( `[data-lg="${ $ownParentID }"]` )
      
      $lgSlick.slick( 'slickNext' );
    } )
    
    // init slick
    $slickElement.slick({
      arrows: false,
      swipeToSlide: true,
      rows: 0,
    });

    $slickElement.on('init', function (event, slick, direction) {
      const container = document.querySelector('.slick-track');
      window.lightGallery(container, {
          plugins: [
              lgZoom
          ],
          preload: 4,
      });
    });
  }
})
